// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'phone-solid';

export const Component = () => (
  <path d='m23.033 20.102-1.631 1.56c-.933.892-2.05 1.338-3.403 1.338-1.072 0-2.004-.268-2.75-.802-2.796-1.784-5.22-3.567-7.27-5.396a54.223 54.223 0 0 1-5.453-6.687C1.826 9.179 1.5 8.198 1.5 7.26c0-1.248.466-2.318 1.445-3.254l1.631-1.561C4.902 2.134 5.23 2 5.602 2c.42 0 .792.134 1.025.446l2.75 2.586c.28.268.42.58.42.981 0 .446-.14.758-.42.982L8.212 8.154c-.186.134-.28.356-.28.624 0 .222.047.356.14.49a22.463 22.463 0 0 0 3.356 4.28 24.065 24.065 0 0 0 4.334 3.166c.233.134.467.178.653.178.326 0 .512-.09.652-.268l1.212-1.115c.233-.267.606-.401 1.026-.401.42 0 .746.134 1.025.401l2.704 2.631c.326.223.466.58.466.981 0 .357-.14.67-.466.981Z' />
);

export const viewBox = '0 0 25 25';
